<template>
  <div>
    <template v-if="content">
      <hr class="mb-4" />
      <div class="font-weight-bold">Intro</div>
      <p>{{ content.intro_text }}</p>
      <div class="font-weight-bold">Costs</div>
      <p>{{ content.costs_text }}</p>
      <div class="font-weight-bold">Other</div>
      <p>{{ content.other_text }}</p>
    </template>
    <v-progress-linear v-else indeterminate :color="colour" />
  </div>
</template>

<script>
export default {
  name: 'ProductListContent',
  props: ['productId', 'colour'],
  computed: {
    content() {
      return this.$store.getters.ProductContent(this.productId);
    }
  },
  created() {
    if (!this.content) {
      this.$store.dispatch('getProductContent', this.productId);
    }
  }
};
</script>
